import React from "react";
import {connect} from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import SwitchCamera from "@material-ui/icons/SwitchCamera";

import styles from "assets/jss/material-dashboard-pro-react/views/form";

import {profileSave, profileFetch} from 'actions/profiles'

import {
  danger,
} from 'actions/notification'

class Platforms extends React.Component {
  button = React.createRef()
	state = {
		form: {
      name: '',
      externalId: ''
    },
    goToNext: true
  }
  componentDidUpdate(prevProps, prevState){
    if (prevProps.additionalWizardData !== this.props.additionalWizardData) {
      this.setData()
    }
    if (prevProps.changeStep !== this.props.changeStep) {
      // handle submit action
      if(this.props.stepDataObject.stepId === this.props.changeStep.currentStep.stepId){
        this.button.current.click()
        this.props.navigationStepChange(this.props.changeStep.nextStep.key)
        this.setState({...this.state, goToNext: false})
      }
    }
  }
  setData(){
    const {profile} = this.props.additionalWizardData
    if(profile){
      this.props.saveWizardData(profile)
      this.setState({
        ...this.state,
        form:{
        name: profile.name,
        externalId: profile.externalId
      }
      })
    }
  }
	change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
	}
	getInput(data){
    return   <CustomInput
        labelText={
          <span>
            {data.name} {(data.required?<small>*</small>: <small>(optional)</small>)}
          </span>
        }
        id={data.key}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event => this.change(event, data.key),
          required:data.required,
          value:this.state.form[data.key] || '',
          type:data.type,
          endAdornment: (
            <InputAdornment
              position="end"
              className={this.props.classes.inputAdornment}
            >
              {data.icon}
            </InputAdornment>
          )
        }}
    />
	}
	submit(e){
    e.preventDefault()
    const history = this.props.history
    const match = this.props.match
    const editmode = match.params.id
    let data = {...this.props.wizardData, ...this.state.form}
    if(this.props.match.url.includes('addDefault') && !editmode){
      data.defaultProfile = true
    }
    this.props.save(data)
      .then(e => {
        if(!editmode){
          history.push(`/administration/profiles/${e.profileId}`)
          
        }
        this.props.saveWizardData(e)
        //this.props.fetch(this.props.match.params.id)
        if(this.state.goToNext) this.props.goToNextStep()
      })
      .catch(e=>{this.props.danger(e+'',4);})
		
	}
  render() {
    const {classes} = this.props
    //console.log(this.state.form)
  	return (
			<form onSubmit={(e) => this.submit(e)}>
				<GridContainer justify="center">
					<GridItem xs={12} sm={11} md={11}>
						{this.getInput({
							key:'name',
							name:'Name of Profile',
							icon:<AssignmentInd className={classes.inputAdornmentIcon}/>,
							type:'text',
							required:true
            })}

            {this.getInput({
							key:'externalId',
							name:'External Id',
							icon:<SwitchCamera className={classes.inputAdornmentIcon}/>,
							type:'text',
							required:false
            })}

					</GridItem>

					<GridItem sm={11}>
						<div style={{float: 'right'}}>
              <button type='submit' ref={this.button} style={{visibility: 'hidden'}}></button>
							<Button
								color="success"
								type="button"
                style={{position:'absolute', bottom:'10px', right:'40px'}}
                onClick={()=> {
                  this.setState({...this.state, goToNext: true})
                  this.button.current.click()
                }}
							>
								Next
							</Button>
						</div>
					</GridItem>
				</GridContainer>
			</form>
  	);
  }
}
const state=(state)=>({
  profiles: state.profiles
})
const dispatch=(dispatch)=>({
  fetch:(id)=>dispatch(profileFetch(id)),
  save:(data)=>dispatch(profileSave(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
})
export default withStyles(styles)(connect(state,dispatch)(Platforms))



// WEBPACK FOOTER //
// ./src/views/Profiles/Wizard/Platforms.jsx